import { localize } from "@/i18n/translate";
export const Wordmark = ({
  dark = false
}) => <img src={dark ? "/brand/logo-light.svg" : "/brand/logo.svg"} alt={localize("Swiss Blockchain Alliance")} width="762" height="208" className="block h-9 w-auto sm:h-11" data-testid={dark ? "site-logo-light" : "site-logo"} />;
